import { Logger } from "@perxis-auto/shared/lib/lib/logger";
import { APP } from "../../config/app.js";
const loggerApp = new Logger(APP.name);
export {
  loggerApp
};
